import { OFFCIRCLE_POI, ERROR_IMPORT } from '../actions/types';

export default function offCircleReducer(state = [], action) {
    switch (action.type) {
        case OFFCIRCLE_POI:
            return action.payload;
        case ERROR_IMPORT:
            return action.payload;
        default:
            return state;
    }
}